// Lightweight Facebook JS SDK loader + login helper.
// The button that uses this is only rendered when REACT_APP_FACEBOOK_APP_ID is set,
// so the SDK is never loaded (and nothing breaks) until Meta keys are configured.

const FB_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
const GRAPH_VERSION = 'v21.0';

export const facebookEnabled = () => Boolean(FB_APP_ID);

let sdkPromise = null;

function loadSdk() {
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve, reject) => {
    if (window.FB) {
      resolve(window.FB);
      return;
    }
    window.fbAsyncInit = function () {
      window.FB.init({ appId: FB_APP_ID, cookie: true, xfbml: false, version: GRAPH_VERSION });
      resolve(window.FB);
    };
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.onerror = () => reject(new Error('Failed to load Facebook SDK'));
    document.body.appendChild(script);
  });
  return sdkPromise;
}

// Opens the Facebook login popup and resolves with a short-lived access token.
export async function facebookLoginPopup() {
  const FB = await loadSdk();
  return new Promise((resolve, reject) => {
    FB.login(
      (response) => {
        if (response.authResponse?.accessToken) {
          resolve(response.authResponse.accessToken);
        } else {
          reject(new Error('cancelled'));
        }
      },
      { scope: 'public_profile,email' }
    );
  });
}
